import {
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Modal,
  ModalOverlay
} from '@chakra-ui/react';
function ModalComponent({
  onClose,
  isOpen,
  title,
  footer,
  children,
  maxWidth,
  modalType,
  variant,
  className,
  maxHeight,
  showCloseIcon = true,
  padding
}: {
  onClose(): void;
  isOpen: boolean;
  title: React.ReactNode;
  footer: React.ReactNode | null;
  children: React.ReactNode;
  maxWidth?: string;
  modalType?: string;
  variant?: number;
  className?: string;
  maxHeight?: string;
  showCloseIcon?: boolean;
  padding?: string
}) {
  const marginTopVal = modalType === "createTransfer" ? "2rem" : "auto";
  return (
    <>
      {!variant || variant === 1 && (
        <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose} isCentered>
          <ModalOverlay background="#000000B2" className="modal-overlay" />
          <ModalContent
            borderRadius="4px"
            padding="30px 50px"
            background="#ffffff"
            width="95vw"
            maxWidth={maxWidth || "801.58px"}
            className={`modal-content ${className || ""}`}
          >
            <button className='modal-close-btn' onClick={onClose}><img src='/images/ui/close.svg' /></button>
            <ModalHeader className="modal-header">
              {title}
            </ModalHeader>
            <ModalBody className="custom-modal__content">
              {children}
            </ModalBody>
            <ModalFooter padding="0" marginTop="30px">
              {footer}
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
      {(
        variant === 2 && (
        <>
          <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose} isCentered>
          <ModalOverlay background="rgba(0, 0, 0, 0.3)" sx={{backdropFilter: 'blur(4px)'}} className="modal-overlay" />
            <ModalContent className={`transfer-create-modal ${className}`} maxWidth={maxWidth || "734px"} maxHeight={maxHeight || "auto"} style={{ marginTop: marginTopVal }}>
              <ModalHeader className='transfer-form-header'>
                {title}
                {showCloseIcon && <button className='transfer-create-modal__close-btn' onClick={onClose}><img src='/images/ui/close.svg' /></button>}
              </ModalHeader>
              <ModalBody className={`transfer-create-modal__body ${className ? className + "-body" : ""}`} p={padding ? padding : ''}>
                {children}
              </ModalBody>
              {footer && (
                <ModalFooter className={`transfer-form-footer ${className ? className + "-footer" : ""}`}>
                  {footer}
                </ModalFooter>
              )}
            </ModalContent>
          </Modal>
        </>
      ))
      }
    </>
  )
}
export default ModalComponent;
